<template>
    <div style="touch-action: none;">
        <div class="home" style="position:fixed;" :style="{ top: top + 'px', bottom: bottom }" id="right-nav" @touchmove="touchmove($event)">
            <div class="homeCon bg-color-red" :class="homeActive === true ? 'on' : ''" v-if="homeActive">
                <router-link :to="'/'" class="iconfont icon-shouye-xianxing"></router-link>
                <router-link :to="'/cart'" class="iconfont icon-caigou-xianxing"></router-link>
                <router-link :to="'/user'" class="iconfont icon-yonghu1"></router-link>
            </div>
            <div @click="open" class="pictrueBox" v-if="type">
                <div class="pictrue">
                    <img :src="
              homeActive === true
                ? require('../assets/images/close.gif')
                : require('../assets/images/open.gif')
            " class="image" />
                </div>
            </div>
        </div>
        <van-dialog v-model="mobileShow" title="手机号绑定" @confirm="mobileCancel">
            <van-field v-model="mobileBD" label="手机号" type="number" placeholder="请输入手机号" />
            <van-field v-model="sms" center clearable label="短信验证码" placeholder="请输入验证码">
                <template #button>
                    <van-button size="small" type="primary" v-if="time==60" @click="send">发送验证码</van-button>
                    <van-button size="small" type="primary" disabled v-if="time<60" style="width:75px">{{time}}S</van-button>
                </template>
            </van-field>
        </van-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import { Dialog, Field, Button, Toast } from 'vant';
import { queryCard, getUserInfo, registerVerify, getCodeApi, bindPhone } from "@api/user";
Vue.use(Dialog);
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);
export default {
    name: "Home",
    props: {},
    data: function() {
        return {
            top: "",
            bottom: "",
            mobileBD: '',
            sms: '',
            mobileShow: false,
            time: 60,
            keyCode: '',
            type: true
        };
    },
    computed: mapGetters(["homeActive"]),
    methods: {
        touchmove(event) {
            this.bottom = "auto";
            event.preventDefault();
            let top =
                event.touches[0].pageY -
                (document.documentElement.scrollTop || document.body.scrollTop) -
                this.$el.clientHeight;
            if (top > document.body.clientHeight - 150) {
                top = document.body.clientHeight - 150;
            } else if (top < 55) top = 55;
            this.top = top;
        },
        open: function() {
            this.homeActive ?
                this.$store.commit("CLOSE_HOME") :
                this.$store.commit("OPEN_HOME");
        },
        mobileCancel(e) {
            let mobileBD = this.mobileBD,
                sms = this.sms,
                reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/
            if (!reg.test(mobileBD)) {
                Toast('手机号有误');
                setTimeout(() => {
                    this.mobileShow = true
                }, 100);
                return
            }
            if (sms == '') {
                Toast('验证码不能为空');
                setTimeout(() => {
                    this.mobileShow = true
                }, 100);
                return
            }
            bindPhone({
                captcha: sms,
                phone: mobileBD
            }).then(res => {
                console.log("success=>", res.msg, res)
                Toast(res.msg);
                // localStorage.setItem('uid',res.data.uid)
                // this.$store.commit("LOGIN", {token:res.data.token});
                setTimeout(() => {
                    this.getUserInfo()
                }, 1000);
            }).catch(err => {
                console.log("fail=>", err.msg, err)
                Toast(err.msg);
                this.getUserInfo()
            })
        },
        /**发送验证码 */
        send() {
            let mobileBD = this.mobileBD,
                reg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/
            if (!reg.test(mobileBD)) {
                Toast('手机号有误');
                return
            }
            registerVerify({
                phone: mobileBD,
                key: this.keyCode,

            }).then(res => {
                this.timer()
            })
        },
        timer() {
            let promise = new Promise((resolve, reject) => {
                let setTimer = setInterval(
                    () => {
                        this.time = this.time - 1
                        if (this.time <= 0) {
                            this.time = 60
                            resolve(setTimer)
                        }
                    }, 1000)
            })
            promise.then((setTimer) => {
                clearInterval(setTimer)
            })
        },
        getUserInfo() {
            getUserInfo().then(res => {
                this.mobileShow = res.data.phone ? false : true
            }).catch(err => {
                // this.mobileShow=true
            })
        },
        getCode() {
            getCodeApi()
                .then(res => {
                    this.keyCode = res.data.key;
                })
                .catch(res => {
                    this.$dialog.error(res.msg);
                });
        },
    },
    created() {
        this.bottom = "90px";
    },
    mounted() {
        this.getCode()
    }
};
</script>
<style scoped>
.pictrueBox {
    width: 1.3rem;
    height: 1.2rem;
}
</style>